<template>
  <div>
    <features>
      <template v-slot:header>
        <div>
          <h1 class="display-2 text-white font-weight-bold mb-0">
            All-in-one monitoring
          </h1>
          <h2 class="display-4 text-white font-weight-light">
            From uptime monitoring to status pages, and everything in-between.
          </h2>
          <p class="text-white mt-4"></p>
        </div>
      </template>
      <template v-slot:hero-image>
        <b-img src="/img/analytics.svg" />
      </template>
      <template v-slot:second>
        <b-col md="6">
          <h2 class="display-3 text-white" style="font-weight: 600;">
            See how
            <span
              class="text-success"
              style="font-weight: 600; display: inline-block;"
            >
              BoltScale
            </span>
            compares.
          </h2>
          <p class="lead text-white mb-6">
            Get robust uptime monitoring and beautiful status pages together.
            And, with tight dependency integrations, you'll wonder why you
            didn't find us sooner.
          </p>
        </b-col>
        <b-col md="10">
          <b-row class="row-grid justify-content-center">
            <b-col lg="10">
              <div class="table-responsive">
                <base-table class="table table-dark mt-5" :data="features">
                  <template slot="columns">
                    <th class="bg-transparent" scope="col">
                      <span class="text-light font-weight-700">Features</span>
                    </th>
                    <th class="text-center bg-transparent" scope="col">
                      BoltScale
                    </th>
                    <th class="text-center bg-transparent" scope="col">
                      Other Uptime Monitors
                    </th>
                    <th class="text-center bg-transparent" scope="col">
                      Other Status Pages
                    </th>
                  </template>

                  <template slot-scope="{ row }">
                    <td class="">
                      {{ row.title }}
                      <i
                        class="fa fa-question-circle"
                        aria-hidden="true"
                        v-b-tooltip.hover.top
                        v-if="row.tooltip"
                        :title="row.tooltip"
                      ></i>
                    </td>
                    <td class="text-center" v-html="row.boltscale"></td>
                    <td class="text-center" v-html="row.uptime"></td>
                    <td class="text-center" v-html="row.status"></td>
                  </template>
                </base-table>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </template>

      <template v-slot:feature-breakdown>
        <section class="py-6"></section>
      </template>
    </features>
  </div>
</template>

<script>
import Features from "@/views/Pages/Features/Features";
import BaseTable from "@/components/BaseTable";
import Payment from "@/components/Payment";
export default {
  name: "pricing-page",
  components: {
    BaseTable,
    Features
  },
  methods: {
    startCheckoutFlow() {
      this.$gtag.event("begin_checkout");
      this.$analytics.fbq.event("InitiateCheckout");
      this.$refs.payment.checkout();
    }
  },
  data() {
    return {
      features: [
        {
          title: "Starting Price",
          boltscale: '<span class="text-sm text-light">$5</span>',
          uptime: '<span class="text-sm text-light">$10</span>',
          status: '<span class="text-sm text-light">$29</span>'
        },
        {
          title: "Public Status Pages",
          boltscale: '<i class="fas fa-check text-success"></i>',
          uptime: "-",
          status: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Private Status Pages",
          boltscale: '<i class="fas fa-check text-success"></i>',
          uptime: "-",
          status: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Slack notifications",
          boltscale: '<i class="fas fa-check text-success"></i>',
          uptime: '<i class="fas fa-check text-success"></i>',
          status: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Email notifications",
          boltscale: '<i class="fas fa-check text-success"></i>',
          uptime: '<i class="fas fa-check text-success"></i>',
          status: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Third-party component notifications",
          tooltip:
            "Subscribe to individual components, like GitHub or Digital Ocean.",
          boltscale: '<i class="fas fa-check text-success"></i>',
          uptime: "-",
          status: "-"
        },
        {
          title: "Third-party incident updates",
          tooltip: "Get incident updates directly from third parties.",
          boltscale: '<i class="fas fa-check text-success"></i>',
          uptime: "-",
          status: "-"
        },
        {
          title: "Response-time monitoring",
          boltscale: '<i class="fas fa-check text-success"></i>',
          uptime: '<i class="fas fa-check text-success"></i>',
          status: "-"
        },
        {
          title: "Subscribers",
          tooltip:
            "Let your customers subscribe to your status page. They'll get notified whenever downtime happens.",
          boltscale: '<i class="fas fa-check text-success"></i>',
          status: '<i class="fas fa-check text-success"></i>',
          uptime: "-"
        },
        {
          title: "Status Page Customization",
          boltscale: '<i class="fas fa-check text-success"></i>',
          status: '<i class="fas fa-check text-success"></i>',
          uptime: "-"
        }
      ]
    };
  },
  mounted() {
    this.$gtag.event("generate_lead");
    this.$analytics.fbq.event("Lead");
  }
};
</script>
<style>
.helptext {
  border-bottom: 2px dotted #ddd;
  cursor: help;
}
</style>
